module.exports = __webpack_public_path__ + "media/images/number_6_green-438bf5435d92679e76d2627891ac8c54.png";